"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preloadSharedAudio = preloadSharedAudio;
const _1 = require("./");
const taskStore_1 = require("../../../taskStore");
const __1 = require("../../..");
function preloadSharedAudio() {
    const sharedAudio = (0, _1.filterMedia)(__1.mediaAssets, [], (0, taskStore_1.taskStore)().assetsPerTask.shared.audio, []);
    return (0, _1.createPreloadTrials)(sharedAudio).default;
}
